export default "__VITE_ASSET__403d972a__"